module.exports = __webpack_public_path__ + "img/Falhas nas linhas de plantio devido erradição de plantas 2.857f0e1a.webp";